// ProtectedRoute.jsx
import React from 'react';
import { Route, Redirect } from 'react-router-dom';

const isAuthenticated = () => !!localStorage.getItem('authToken'); // Checks for authToken

const ProtectedRoute = ({ component: Component, ...rest }) => {
  return (
    <Route
      {...rest}
      render={props =>
        isAuthenticated() ? (
          <Component {...props} />
        ) : (
          // <Redirect to="/login" />
          <Redirect to="/" />
        )
      }
    />
  );
};

export default ProtectedRoute;
